import { Typography } from '@material-ui/core';
import { FC } from 'react';

import useUserDashboardStyles from '../../hooks/styles/userDashboardStyles';
import { useLaborable } from '../commons/laborableContext/LaborableHook';
import { getGMTString } from '../commons/utils/timezoneUtils';

export const GMTDrawer: FC = () => {
  const { weeklySchedule } = useLaborable()
  const classes = useUserDashboardStyles()

  if (!weeklySchedule) return null;

  return (
    <Typography className={classes.welcomeTitle}>
      {getGMTString(weeklySchedule.timezone as string)}
    </Typography>
  );
}
